import { DwsimProDialogType } from "../../swagger-clients/s365-admin-panel-clients.service";

export const getDwsimProDialogTypeLabel = (value?: DwsimProDialogType) => {

    if (value === undefined || value === null)
        return null;
    switch (value) {
        case DwsimProDialogType.BusinessEmail_NotConfirmed:
            return "Confirm business email";
        case DwsimProDialogType.Eula:
            return "Eula";
        case DwsimProDialogType.BusinessEmail_SubmitForm:
            return "Submit Business Email";
        case DwsimProDialogType.FeedbackForm:
            return "Feedback";
        case DwsimProDialogType.RegistrationEmail_NotConfirmed:
            return "Confirm registration email";
        case DwsimProDialogType.Licensing_EligibleForTrial:
            return "Licensing - Eligible for Trial";
        case DwsimProDialogType.Licensing_EnterCreditCard:
            return "Licensing - Enter Credit Card";
        case DwsimProDialogType.Licensing_NoLicense:
            return "No License";
        default:
            return `Missing mapping for ${value}`;
    }

}
export const DwsimProDialogTypes:DwsimProDialogType[]=[
    DwsimProDialogType.BusinessEmail_SubmitForm,
    DwsimProDialogType.BusinessEmail_NotConfirmed,
    DwsimProDialogType.RegistrationEmail_NotConfirmed,
    DwsimProDialogType.Eula,
    DwsimProDialogType.FeedbackForm,
    DwsimProDialogType.Licensing_EnterCreditCard,
    DwsimProDialogType.Licensing_EligibleForTrial,
    DwsimProDialogType.Licensing_NoLicense];